import type { FinalCtaContent } from "../types";

export const finalCta: FinalCtaContent = {
  draftingLabels: ["TAVLE 01", "UCLOUD AI / INFRASTRUKTUR", "REV. 01 / SYSTEM KLAR"],
  titleLine1: "Suveræn AI, ",
  titleLine2: "skabt i Danmark.",
  subtitle:
    "Log ind med dit universitetslogin, vælg en model og løft din " +
    "forskning til det næste niveau. Dine data forbliver i Danmark, og du " +
    "beholder kontrollen.",
  ctaPrimary: "Prøv det",
  ctaSecondary: "Kontakt os",
};
